module.exports = __webpack_public_path__ + "img/milky_backend.d351cbde.png";